import {HttpService} from "../http/HttpService";
import {BudgetPermissionLimits} from "../http/protocol";

export class PermissionLimitService {

    constructor(private http: HttpService) {}

    getPermissionLimits(): Promise<BudgetPermissionLimits> {
        return this.http.get("/permission-limits");
    }

    updatePermissionLimits(limits: BudgetPermissionLimits): Promise<BudgetPermissionLimits> {
        return this.http.put("/permission-limits", limits);
    }
}

